import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout";
import { useNavigate } from "react-router-dom";
import { TbReportAnalytics } from "react-icons/tb";
import { HiUsers } from "react-icons/hi";
import { MdOutlineAssessment, MdAssignment } from "react-icons/md";
import { RiBarChartGroupedLine } from "react-icons/ri";
import { useGetCampusQuery, useGetStaffByEmailIdQuery } from "../../../../graphql/generated.tsx";

export default function WorkInstructionSlide() {
  const navigate = useNavigate();
  const email = JSON.parse(localStorage.getItem("user"))?.email;
  const { data: staffData } = useGetStaffByEmailIdQuery({ variables: { email } });
  const { data: campusDetails } = useGetCampusQuery({
    variables: { id: staffData?.getStaffByEmailId?.campusId },
    skip: !staffData?.getStaffByEmailId?.campusId,
  });
  const campusName = campusDetails?.campus?.name;

  const items = [
    {
      id: "student-insights",
      title: "Student Dashboard",
      summary: "Start here to check individual student dashboards and real-time activity at a glance.",
      tag: "To view a student dashboard",
      path: "/admin/individual-report",
      icon: TbReportAnalytics,
      top: "#3b82f6",
      iconBg: "#eff6ff",
      iconColor: "#3b82f6",
      tagBg: "#eff6ff",
      tagColor: "#1d4ed8",
    },
    {
      id: "course-leetcode-progress",
      title: "Courses and LeetCode",
      summary: "Move here to track course completion and LeetCode progress in one clear view.",
      tag: "To download batch wise course and LeetCode timely completion report",
      path: campusName ? `/admin/reports/course/${campusName}` : "/admin/reports/assignments",
      icon: HiUsers,
      top: "#10b981",
      iconBg: "#ecfdf5",
      iconColor: "#10b981",
      tagBg: "#ecfdf5",
      tagColor: "#065f46",
    },
    {
      id: "batch-assignment-review",
      title: "Daily Assignment Report",
      summary: "Review batch-wise assignment scores, submission status, and assignment details together.",
      tag: "To download batch wise assignment report",
      path: "/admin/assignment-report",
      icon: MdOutlineAssessment,
      top: "#f59e0b",
      iconBg: "#fffbeb",
      iconColor: "#f59e0b",
      tagBg: "#fffbeb",
      tagColor: "#92400e",
    },
    {
      id: "campus-assignment-leaderboard",
      title: "Campus Top Assignment Performers",
      summary: "Review overall assignment rankings and top performers across the campus.",
      tag: "Download top 100 / top 50 / least 50",
      path: "/admin/reports/assignments",
      icon: MdAssignment,
      top: "#ec4899",
      iconBg: "#fdf2f8",
      iconColor: "#ec4899",
      tagBg: "#fdf2f8",
      tagColor: "#9d174d",
    },
    {
      id: "comprehensive-report",
      title: "Cumulative Progress Tracker",
      summary: "For a selected training phase or time interval, view assignment progress, overall LeetCode performance, and course completion data in one view.",
      tag: "Download assignment scores for a selected training phase or entire course in a single sheet",
      path: "/admin/student-details",
      icon: RiBarChartGroupedLine,
      top: "#8b5cf6",
      iconBg: "#f5f3ff",
      iconColor: "#8b5cf6",
      tagBg: "#f5f3ff",
      tagColor: "#5b21b6",
    },
  ];

  return (
    <AdminLayout>
      <div className="w-full min-h-screen px-4 py-8 bg-white sm:px-6 sm:py-10 lg:px-10 lg:py-12">
        <div className="mb-8 text-center sm:mb-10 lg:mb-12">
          <p className="text-[11px] font-semibold tracking-[0.2em] uppercase text-slate-400 mb-2">
            Staff Portal
          </p>
          <h1 className="mb-3 text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Staff Guidelines
          </h1>
          <p className="max-w-md mx-auto text-sm leading-relaxed text-slate-500 sm:text-base">
            Follow the flow from student insights to course progress, batch reviews, campus rankings, and the final overview.
          </p>
        </div>

        <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => navigate(item.path)}
                style={{ borderTop: `3.5px solid ${item.top}` }}
                className="flex flex-col p-4 text-left transition-all duration-200 bg-white border group rounded-2xl border-slate-200 hover:border-slate-300 hover:shadow-lg sm:p-5"
              >
                <div
                  className="flex items-center justify-center flex-shrink-0 w-10 h-10 mb-3 rounded-xl sm:mb-4 sm:w-11 sm:h-11"
                  style={{ background: item.iconBg, color: item.iconColor }}
                >
                  <Icon className="w-5 h-5" />
                </div>

                <div className="flex-1">
                  <h3 className="mb-2 text-base font-bold text-slate-800 sm:mb-3 sm:text-lg">
                    {item.title}
                  </h3>
                  <p className="text-xs leading-relaxed text-slate-500 sm:text-sm">
                    {item.summary}
                  </p>
                </div>

                <div className="flex items-center justify-between pt-3 mt-4 border-t border-slate-100">
                  <span
                    className="text-[13px] underline cursor-pointer"
                    style={{ color: item.tagColor, fontFamily: "Poppins, sans-serif" }}
                  >
                    {item.tag}
                  </span>
                  <span className="text-xs transition-all -translate-x-1 opacity-0 text-slate-400 group-hover:opacity-100 group-hover:translate-x-0">
                    ↗
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </AdminLayout>
  );
}
